import * as $runtime from "../runtime.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dJSDate from "../Data.JSDate/index.js";
import * as Data$dLeibniz from "../Data.Leibniz/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dValue from "../Restaumatic.Form.Value/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Specular$dSelect from "../Specular.Select/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import {_setElementProperty} from "./foreign.js";
const identity = x => x;
const liftHost = /* #__PURE__ */ Specular$dFRP$dHost.liftHost(Specular$dDom$dBuilder.monadCleanupBuilder)(Specular$dInternal$dRIO.monadEffectRIO);
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Specular$dDom$dElement.monoidProp)(Data$dFoldable.identity))();
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const subscribeDyn = /* #__PURE__ */ Specular$dFRP$dBase.subscribeDyn({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dFRP$dHost.monadCleanupHost
});
const asDateTimeMaybeDateTime = {fromMaybeDateTime: Data$dMaybe.Just, toMaybeDateTime: identity};
const asDateTimeDateTime = {fromMaybeDateTime: identity, toMaybeDateTime: Data$dMaybe.Just};
const asDateMaybeDay = /* #__PURE__ */ (() => (
  {
    fromMaybeDate: x => Data$dMaybe.$Maybe("Just", x.tag === "Just" ? Data$dMaybe.$Maybe("Just", x._1) : Data$dMaybe.Nothing),
    toMaybeDate: Data$dMaybe.functorMaybe.map(Unsafe$dCoerce.unsafeCoerce)
  }
))();
const asDateMaybeDate = {fromMaybeDate: Data$dMaybe.Just, toMaybeDate: identity};
const asDateDay = /* #__PURE__ */ (() => ({fromMaybeDate: Data$dMaybe.functorMaybe.map(Unsafe$dCoerce.unsafeCoerce), toMaybeDate: x => Data$dMaybe.$Maybe("Just", x)}))();
const asDateDate = {fromMaybeDate: identity, toMaybeDate: Data$dMaybe.Just};
const toMaybeDateTime = dict => dict.toMaybeDateTime;
const toMaybeDate = dict => dict.toMaybeDate;
const setElementProperty = name => value => (node, v) => _setElementProperty(node, name, value);
const select = dictShow => {
  const showMaybe = {
    show: v => {
      if (v.tag === "Just") { return "(Just " + dictShow.show(v._1) + ")"; }
      if (v.tag === "Nothing") { return "Nothing"; }
      $runtime.fail();
    }
  };
  return dictEq => {
    const select1 = Specular$dSelect.select({
      eq: x => y => {
        if (x.tag === "Nothing") { return y.tag === "Nothing"; }
        if (x.tag === "Just") {
          if (y.tag === "Just") { return dictEq.eq(x._1)(y._1); }
          return false;
        }
        return false;
      }
    })(showMaybe);
    return dictToOptionId => {
      const select2 = select1({
        toOptionId: v => {
          if (v.tag === "Nothing") { return ""; }
          if (v.tag === "Just") { return dictToOptionId.toOptionId(v._1); }
          $runtime.fail();
        }
      });
      return dictIsSelectField => props => f => Specular$dInternal$dRIO.bindImpl(liftHost(Restaumatic$dForm$dInternal.selectInput(dictShow)(dictEq)(dictIsSelectField)(f)))(i => select2([
        Specular$dDom$dElement.on("blur")(v => i.onTouch),
        fold(props)
      ])(i.displayedOptions)(Specular$dRef.$Ref(
        i.displayedValue,
        cb => {
          const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(i.displayedValue);
          return () => {
            const old = $0();
            return for_(cb(old))(value => i.onChange(value))();
          };
        }
      )));
    };
  };
};
const radio = dictShow => dictEq => dictIsSelectField => groupName => option => props => f => Specular$dInternal$dRIO.bindImpl(liftHost(Restaumatic$dForm$dInternal.selectInput(dictShow)(dictEq)(dictIsSelectField)(f)))(i => {
  const boolDisplay = Specular$dFRP$dBase.functorDynamic.map(v => {
    if (v.tag === "Just") {
      if (v._1.tag === "Just") { return dictEq.eq(v._1._1)(option.key); }
      return false;
    }
    return false;
  })(i.displayedValue);
  return Specular$dDom$dElement.el("input")(Data$dSemigroup.concatArray([
    Specular$dDom$dElement.bindChecked(Specular$dRef.$Ref(
      boolDisplay,
      cb => {
        const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(boolDisplay);
        return () => {
          const old = $0();
          if (cb(old)) { return i.onChange(Data$dMaybe.$Maybe("Just", option.key))(); }
        };
      }
    )),
    Specular$dDom$dElement.attr("type")("radio"),
    Specular$dDom$dElement.attr("name")(groupName),
    Specular$dDom$dElement.on("blur")(v => i.onTouch)
  ])(props))(Restaumatic$dPrelude$dSpecular.wempty);
});
const genericTextInput = dictIsTextField => tag => bindValue => props => field => {
  const i = dictIsTextField.textInput(field);
  return Specular$dDom$dElement.el(tag)(Data$dSemigroup.concatArray([
    bindValue(Specular$dRef.$Ref(
      i.displayedValue,
      f => {
        const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(i.displayedValue);
        return () => {
          const old = $0();
          return i.onChange(f(old))();
        };
      }
    )),
    Specular$dDom$dElement.on("blur")(v => i.onTouch),
    Specular$dDom$dElement.attrD("placeholder")(i.placeholder)
  ])(props))(Restaumatic$dPrelude$dSpecular.wempty);
};
const textArea = dictIsTextField => genericTextInput(dictIsTextField)("textarea")(Specular$dDom$dElement.bindValueOnChange);
const textInput = dictIsTextField => props => genericTextInput(dictIsTextField)("input")(Specular$dDom$dElement.bindValueOnChange)(props);
const textLiveInput = dictIsTextField => props => genericTextInput(dictIsTextField)("input")(Specular$dDom$dElement.bindValueOnInput)(props);
const fromMaybeDateTime = dict => dict.fromMaybeDateTime;
const fromMaybeDate = dict => dict.fromMaybeDate;
const fieldId = dictHasFieldId => field => Specular$dDom$dElement.attr("data-field-id")(dictHasFieldId.getFieldId(field));
const fieldWrapper = dictHasFieldId => field => Specular$dDom$dElement.el("div")([fieldId(dictHasFieldId)(field)]);
const dateTimePickerLocal = dictIsRefLike => dictAsDateTime => () => () => params => {
  const $0 = {props: [], min: Data$dMaybe.Nothing, ...params};
  const $1 = $0.field;
  const $2 = $0.min;
  const $3 = $0.props;
  return Specular$dInternal$dRIO.bindImpl(liftHost(subscribeDyn(x => {
    const $4 = x.tag === "Just" ? dictAsDateTime.toMaybeDateTime(x._1) : Data$dMaybe.Nothing;
    if ($4.tag === "Just") { return DateUtils.formatNativeDateTimePicker(Data$dJSDate.fromDateTime($4._1)); }
    if ($4.tag === "Nothing") { return () => ""; }
    $runtime.fail();
  })(dictIsRefLike.readRefLike($1))))(displayedValue => Specular$dInternal$dRIO.bindImpl((() => {
    if ($2.tag === "Nothing") { return () => Specular$dDom$dElement.monoidProp.mempty; }
    if ($2.tag === "Just") {
      const $4 = DateUtils.formatNativeDateTimePicker(Data$dJSDate.fromDateTime($2._1));
      return () => {
        const val = $4();
        return Specular$dDom$dElement.attr("min")(val);
      };
    }
    $runtime.fail();
  })())(minDateProp => Specular$dDom$dElement.el("input")(Data$dSemigroup.concatArray([
    Specular$dDom$dElement.bindValueOnChange(Specular$dRef.$Ref(
      displayedValue,
      f => {
        const $4 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(displayedValue);
        return () => {
          const old = $4();
          const str = f(old);
          const parsed = Data$dJSDate.parse(str)();
          return dictIsRefLike.writeRefLike($1)((() => {
            const v1 = dictAsDateTime.fromMaybeDateTime((() => {
              const $5 = Data$dJSDate.toInstant(parsed);
              if ($5.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dDateTime$dInstant.toDateTime($5._1)); }
              return Data$dMaybe.Nothing;
            })());
            if (v1.tag === "Nothing") {
              return Restaumatic$dForm$dInternal.$TypedValue(
                "Invalid",
                {
                  error: str === ""
                    ? Restaumatic$dForm$dFinal.userVisibleErrors([
                        Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
                      ])
                    : Restaumatic$dForm$dFinal.userVisibleErrors([
                        Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.invalid), {})
                      ]),
                  lastValid: Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl),
                  editValue: Data$dMaybe.$Maybe("Just", str)
                }
              );
            }
            if (v1.tag === "Just") { return Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: v1._1, editValue: Data$dMaybe.$Maybe("Just", str)}); }
            $runtime.fail();
          })())();
        };
      }
    )),
    Specular$dDom$dElement.on("blur")(v1 => dictIsRefLike.touchRefLike($1)),
    Specular$dDom$dElement.attr("type")("datetime-local"),
    minDateProp
  ])($3))(Restaumatic$dPrelude$dSpecular.wempty)));
};
const datePicker = dictIsRefLike => dictAsDate => props => field => {
  const displayedValue = Specular$dFRP$dBase.functorDynamic.map(x => {
    const $0 = x.tag === "Just" ? dictAsDate.toMaybeDate(x._1) : Data$dMaybe.Nothing;
    if ($0.tag === "Nothing") { return ""; }
    if ($0.tag === "Just") { return DateUtils.formatISODate($0._1); }
    $runtime.fail();
  })(dictIsRefLike.readRefLike(field));
  return Specular$dDom$dElement.el("input")(Data$dSemigroup.concatArray([
    Specular$dDom$dElement.bindValueOnChange(Specular$dRef.$Ref(
      displayedValue,
      f => {
        const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(displayedValue);
        return () => {
          const old = $0();
          const str = f(old);
          return dictIsRefLike.writeRefLike(field)((() => {
            const v = (() => {
              if (str === "") { return dictAsDate.fromMaybeDate(Data$dMaybe.Nothing); }
              const $1 = DateUtils.parseISODate(str);
              if ($1.tag === "Just") { return dictAsDate.fromMaybeDate(Data$dMaybe.$Maybe("Just", $1._1)); }
              return Data$dMaybe.Nothing;
            })();
            if (v.tag === "Nothing") {
              return Restaumatic$dForm$dInternal.$TypedValue(
                "Invalid",
                {
                  error: str === ""
                    ? Restaumatic$dForm$dFinal.userVisibleErrors([
                        Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
                      ])
                    : Restaumatic$dForm$dFinal.userVisibleErrors([
                        Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.invalid), {})
                      ]),
                  lastValid: Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl),
                  editValue: Data$dMaybe.$Maybe("Just", str)
                }
              );
            }
            if (v.tag === "Just") { return Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: v._1, editValue: Data$dMaybe.$Maybe("Just", str)}); }
            $runtime.fail();
          })())();
        };
      }
    )),
    Specular$dDom$dElement.on("blur")(v => dictIsRefLike.touchRefLike(field)),
    Specular$dDom$dElement.attr("type")("date")
  ])(props))(Restaumatic$dPrelude$dSpecular.wempty);
};
const customField = dictEncode => dictDecode => {
  const $0 = Unscramble.decodeMaybe(dictDecode);
  return spec => {
    const $1 = setElementProperty("getCustomFieldProperties")((() => {
      const $1 = spec.getValue;
      return () => {
        const value = $1();
        return {
          value: (() => {
            if (value.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
            if (value.tag === "Just") { return dictEncode.encode(value._1); }
            $runtime.fail();
          })()
        };
      };
    })());
    const $2 = setElementProperty("setCustomFieldValue")(x => spec.setValue($0.unsafeDecode(x))());
    return (node, cleanups) => {
      fieldId(Restaumatic$dForm$dInternal.hasFieldIdString)(spec.id)(node, cleanups);
      Specular$dDom$dElement.attr("data-custom-field-type")(spec.subtype)(node, cleanups);
      $1(node, cleanups);
      return $2(node, cleanups);
    };
  };
};
const checkbox = dictIsCheckboxField => props => field => Specular$dInternal$dRIO.bindImpl(liftHost(dictIsCheckboxField.checkboxInput(field)))(i => Specular$dDom$dElement.el("input")(Data$dSemigroup.concatArray([
  Specular$dDom$dElement.bindChecked(Specular$dRef.$Ref(
    i.displayedValue,
    f => {
      const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(i.displayedValue);
      return () => {
        const old = $0();
        return i.onChange(f(old))();
      };
    }
  )),
  Specular$dDom$dElement.attr("type")("checkbox")
])(props))(Restaumatic$dPrelude$dSpecular.wempty));
export {
  asDateDate,
  asDateDay,
  asDateMaybeDate,
  asDateMaybeDay,
  asDateTimeDateTime,
  asDateTimeMaybeDateTime,
  checkbox,
  customField,
  datePicker,
  dateTimePickerLocal,
  fieldId,
  fieldWrapper,
  fold,
  for_,
  fromMaybeDate,
  fromMaybeDateTime,
  genericTextInput,
  identity,
  liftHost,
  radio,
  select,
  setElementProperty,
  subscribeDyn,
  textArea,
  textInput,
  textLiveInput,
  toMaybeDate,
  toMaybeDateTime
};
export * from "./foreign.js";
